import { ClientService } from '@core/services/client/client.service';
import { Client} from '@core/services/client/client.model';
import { FormControl } from '@angular/forms';
import { timer } from 'rxjs';
import { switchMap, map,delay  } from 'rxjs/operators';
import { Observable,of } from 'rxjs';
import { UserService } from '@core/services/user/user.service';
import moment, { Moment } from 'moment';



export const ClientIdAsyncValidator = (clientService: ClientService, time: number = 200) => {
      return  (input: FormControl) => {
           console.log("ClientIdAsyncValidator",input.value);
           let val = input.value;
           if (val === null|| val === '') return { 'required': true };
           if (!val.toString().trim().match(/^[0-9]+(\.?[0-9]+)?$/))  return { 'invalidNumber': true };

        // return { ClientIdExist: true };
        if (clientService.allClientModels.find(x => x.id === val))
         {
           return { ClientIdExist: true };
         }
         else
         {
           return null;
         }
   };
 
};

export const FileDescriptionAsyncValidator = (clientService: ClientService,clientId:number,fileid:number) => {
  return (input: FormControl) => {
    let val = input.value;
    if (val === null|| val === '') return { 'required': true };
    if(clientService.strfiledescriptions.filter(x=>x.clientid==clientId))
    {
        if(clientService.strfiledescriptions.filter(x=>x.clientid==clientId).find(x=>x.description.trim()===val.trim() && x.fileid!=fileid))
       {
        console.log("updateitem 01 fileid",fileid);
           return { FileDescriptionExist: true };
       }
    }
  
      return null;
    
  };
};

export const EmailTypeAsyncValidator = () => {
  return (input: FormControl) => {
    let val = input.value;
    console.log("log",val);
    if(val==="") return { 'required': true };
  };
};


export const EmailAsyncValidator = (clientService: ClientService,time: number = 200) => {
  return (input: FormControl) => {
    return  clientService.CheckEmailexisting(input.value).pipe(delay(time),map(data=>{
      console.log("data",data? { EmailExist: true }:null);
      return data? { EmailExist: true }:null;
    }));    
  };
};

export const EmailsAsyncValidator=()=>{
  return (input:FormControl) =>{
    let val = input.value;
    if(val==="" || val==null) return null;
    var emails=val.split(";");
    if(emails.length>0)
    {
     for(var i=0;i<emails.length;i++)
     {
        if(!emails[i].toString().trim().match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/) && emails[i]!="")
        {
          return { 'invaildemail': true };
        }
     }
    }   
     return null;
  }
}

export const TimeCompareAsyncValidator=(starttime:Moment)=>{
  return (input: FormControl) => {
      let val = input.value;
      if(val!="")
      {
         var endTime = moment(val, 'h:mma');
         var beginningTime = moment(starttime, 'h:mma');
         if(beginningTime.isBefore(endTime) || beginningTime.isSame(endTime))
         {
             return  { timeerror: true };
         }
         return null;
      }

  };
}

export class CustomValidator{
  // Number only validation
  static numeric(input: FormControl)  {
    let val = input.value;
    if (val === null || val === '') return null;
    if (!val.toString().match(/^[0-9]+(\.?[0-9]+)?$/)) return { 'invalidNumber': true };
    return null;
  }
};

export const YearAsyncValidator = (year: string) => {
  return  (input: FormControl) => {    
    let val = input.value;
    
     val= (val).getFullYear().toString()  
    if (year != val) {
      return { SelectedYear: true };
    }
    else {   
      return null;

    }   
};

};



export const DateYearValidatioon = () => {
  return  (input: FormControl) => {    
    let val = input.value;
    
    if (val == "") {
      return { SelectedDate: true };
    }
    else {   
      return null;

    }   
};



};
